export default Object.freeze({
  id: '',
  title: '',
  startDate: '',
  endDate: '',
  voteUserMax: 5,
  activities: [],
  anonymousAuthors: false,
  linkHash: '',
  users: [],
  teams: []
});
